import * as R from 'ramda';
import { arrayHelper } from 'utils/arrayHelper';
import { stateHelper } from 'utils/stateHelper';

const INITIAL_ITEMS = [
    {
        spacer: true,
        order: -100,
    },
];

const module = stateHelper.createModuleState('AppHeader', {
    items: INITIAL_ITEMS,
});

let idCounter = 1;

const addItem = (item) => (dispatch, getState) => {
    const id = item.id || idCounter++;

    item = {
        ...item,
        id,
        items: _addIds(item.items),
    };

    const items = R.pipe(R.append(item), _sortDeep)(getItems(getState()));

    dispatch(module.setPart('items', items));

    return id;
};

const _addIds = (items) => {
    return (
        items &&
        items.map((subitem) => {
            if (subitem.id == null) {
                subitem.id = idCounter++;
            }
            return subitem;
        })
    );
};

const _sortByOrderProp = R.sortBy(R.prop('order'));

const _sortSubitems = (item) => {
    if (item.items) {
        return {
            ...item,
            items: _sortDeep(item.items),
        };
    }
    return item;
};

const _sortDeep = (items) =>
    R.pipe(R.map(_sortSubitems), _sortByOrderProp)(items);

const addSubitem = (itemId, subitem) => (dispatch, getState) => {
    const id = subitem.id || idCounter++;

    subitem = {
        ...subitem,
        id,
    };

    let item = getItem(getState(), itemId);
    item = {
        ...item,
        items: _sortDeep(item.items.concat(subitem)),
    };

    dispatch(
        module.setPart(
            'items',
            arrayHelper.getListWithInsertedItem({
                list: getItems(getState()),
                item,
            }),
        ),
    );

    return id;
};

const removeItem = (id) => (dispatch, getState) => {
    const items = R.reject(R.propEq('id', id), getItems(getState()));

    dispatch(module.setPart('items', items));
};

const removeSubitem = (itemId, subitemId) => (dispatch, getState) => {
    const item = getItem(getState(), itemId);
    item.items = R.reject(R.propEq('id', subitemId))(item.items);

    const items = arrayHelper.getListWithInsertedItem({
        list: getItems(getState()),
        item,
    });

    dispatch(module.setPart('items', items));
};

const updateItem = (itemId, params) => (dispatch, getState) => {
    let item = getItem(getState(), itemId);

    if (!params.hasOwnProperty('items')) {
        params.items = item.items;
    }

    item = {
        ...item,
        ...params,
        items: _addIds(params.items),
    };

    let items = arrayHelper.getListWithInsertedItem({
        list: getItems(getState()),
        item,
    });
    items = _sortDeep(items);

    dispatch(module.setPart('items', items));
};

const updateSubitem = (itemId, subitemId, params) => (dispatch, getState) => {
    const item = getItem(getState(), itemId);
    let subitem = item.items.find(R.propEq('id', subitemId));
    subitem = {
        ...subitem,
        ...params,
    };
    item.items = arrayHelper.getListWithInsertedItem({
        list: item.items,
        item: subitem,
    });

    dispatch(updateItem(itemId, item));
};

export const AppHeaderActions = {
    addItem,
    addSubitem,
    removeItem,
    removeSubitem,
    updateItem,
    updateSubitem,
};

const getItems = (state) => module.getPart(state, 'items');
const getItem = (state, id) => getItems(state).find(R.propEq('id', id));

export const AppHeaderSelectors = {
    getItems,
    getItem,
};
